import { Wrapper, TableTitle, TableWrapper, AddNewRowBtn, RemoveRowBtn } from './styles';
import { useMemo, useState, useEffect } from 'react';
import { useTable } from 'react-table';
import EditableCell from '../EditableCell';
import ImportModal from '../ImportModal';
import { ImportBtn } from '../DocumentationListEdit/styles';

const tableHeaders = [
  {
    Header: 'Tag #',
    columns: [
      {
        Header: 'Tag # 2',
        displayNone: true,
        columns: [{ Header: 'Tag # 3', accessor: 'tagNr', displayNone: true }],
      },
    ],
    rowSpan: '3',
  },
  {
    Header: 'Product Description',
    columns: [
      {
        Header: 'Product Description INVISIBLE',
        displayNone: true,
        columns: [
          {
            Header: 'Product Description INVISIBLE',
            accessor: 'description',
            displayNone: true,
          },
        ],
      },
    ],
    rowSpan: '3',
  },
  {
    Header: 'Comment',
    columns: [
      {
        Header: 'Comment INVISIBLE',
        displayNone: true,
        columns: [
          {
            Header: 'Comment INVISIBLE',
            accessor: 'comment',
            displayNone: true,
          },
        ],
      },
    ],
    rowSpan: '3',
  },
  {
    Header: () => null,
    id: 'remove_Row_Btn',
    Cell: ({ row: { index }, deleteRow }) => (
      <RemoveRowBtn
        onClick={() => {
          deleteRow(index);
        }}
      />
    ),
  },
];

const defaultColumn = {
  Cell: EditableCell,
};

const EquipmentListEdit = ({ title,
                             idCard,
                             showUploadBtn,
                             tableData,
                             setEditedDataField }) => {
  const [skipPageReset, setSkipPageReset] = useState(false);
  const columns = useMemo(() => tableHeaders, []);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const Table = ({ columns, data, updateCellData, skipPageReset, deleteRow }) => {
    const tableInstance = useTable({
      columns,
      data,
      defaultColumn,
      // use the skipPageReset option to disable page resetting temporarily
      autoResetPage: !skipPageReset,
      // updateCellData isn't part of the API, but
      // anything we put into these options will
      // automatically be available on the instance.
      // That way we can call this function from our
      // cell renderer!
      updateCellData,
      deleteRow,
    });

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

    return (
      <table {...getTableProps()}>
        <colgroup>
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  rowSpan={`${column.rowSpan ?? 1}`}
                  style={column.displayNone ? { display: 'none' } : {}}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            Object.keys(row.values).forEach((valueKey) => {
              row.values[valueKey] = row.values[valueKey] ?? '';
            });
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  // When our cell renderer calls updateCell, we'll use
  // the rowIndex, columnId and new value to update the
  // original data
  const updateCellData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    setSkipPageReset(true);

    let currentData = tableData.map((row, index) => {
      if (index === rowIndex) {
        return {
          ...tableData[rowIndex],
          [columnId]: value,
        };
      }
      return row;
    });
    setEditedDataField('equipmentList', currentData);
  };

  const deleteRow = (rowIndex) => {
    setSkipPageReset(true);
    let currentData = [...tableData];
    currentData.splice(rowIndex, 1);
    setEditedDataField('equipmentList', currentData);
  };

  const addNewRow = () => {
    let currentData = [...tableData];
    currentData.push({
      tag: '',
      description: '',
      comment: '',
    });
    setEditedDataField('equipmentList', currentData);
  };

  const openImportModalHandler = () => {
    setIsImportModalOpen(true);
  };

  const closeImportModalHandler = () => {
    setIsImportModalOpen(false);
  };

  // After data chagnes, we turn the flag back off
  // so that if data actually changes when we're not
  // editing it, the page is reset
  useEffect(() => {
    setSkipPageReset(false);
  }, [tableData]);

  return (
    <Wrapper>
      <TableTitle
        placeholder='Equipment List Comment...'
        value={title}
        onChange={(e) => {
          setEditedDataField(e.target.name, e.target.value);
        }}
        name='equipmentListComment'
        type='text'
      />
      {showUploadBtn && <ImportBtn title={'Import equipment list'} type={'rounded'} onClick={openImportModalHandler}/>}
      {isImportModalOpen && (
        <ImportModal
          idCard={idCard}
          title="Upload your CSV file"
          resourceType="equipment"
          description={`Please select a CSV file to upload.`}
          onClose={closeImportModalHandler}
        />
      )}
      <TableWrapper>
        <Table
          columns={columns}
          data={tableData}
          updateCellData={updateCellData}
          skipPageReset={skipPageReset}
          deleteRow={deleteRow}
        />
      </TableWrapper>
      <AddNewRowBtn
        title={'add row'}
        onClick={addNewRow}
      />
    </Wrapper>
  );
};

export default EquipmentListEdit;
